import {
  APPLY_PROMO_CODE,
  CLEAR_PROMO_CODE,
  MAKE_A_PAYMENT,
  REQUEST_PROMO_CODE,
  UPDATE_PRICE,
  UPDATE_PROMO_CODE,
} from './ActionTypes';

export const payment_authentication = (paymentBody, success = () => {
}, callback = () => {
}) => {
  return {
    type: MAKE_A_PAYMENT,
    paymentBody: paymentBody,
    success,
    callback,
  };
};

export const promo_code_request = requestBody => {
  return {
    type: REQUEST_PROMO_CODE,
    requestBody: requestBody,
  };
};

export const update_promo_code = (couponCode, discountPrice) => {
  return {
    type: UPDATE_PROMO_CODE,
    couponCode: couponCode,
    discountPrice: discountPrice,
  };
};

export const apply_promo_code = requestBody => {
  return {
    type: APPLY_PROMO_CODE,
    requestBody: requestBody,
  };
};

export const update_price = netAmount => {
  return {
    type: UPDATE_PRICE,
    netAmount: netAmount,
  };
};

export const clear_promo_code = () => {
  return {
    type: CLEAR_PROMO_CODE,
  };
};
